module.exports = __webpack_public_path__ + "img/9788960174573.718a8b67.jpg";